/** Form-side composition row. `percentage` stays a string so the input can be
 * empty ("não especificada") without fighting number coercion. */
export interface CompositionDraft {
  materialId: string;
  percentage: string;
}

export function compositionSum(value: CompositionDraft[]): number {
  return value.reduce((acc, row) => acc + (row.percentage === '' ? 0 : Number(row.percentage)), 0);
}
